import axios from "axios";
import { API_BASE_URL } from "../environment";

export const addNewExpenses = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=expenses`, data);
  return res.data;
};
export const getAllExpenses = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/expenses?user_id=${data.user_id}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};

export const getDisbursement = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/filter/disbursement`, data);
  return res.data;
};

export const getAllPaymentsAndDisbursment = async (data) => {
  const res = await axios.get(`${API_BASE_URL}/filter/allPaymentData?user_id=${data.user_id}&id=${data.id}&start_date=${data.start_date}&end_date=${data.end_date}&type=${data.type}`)
  return res.data;
}